export interface Appendix3Data {
	typeName: string;
    salesBalance: string;
	actualBalance: string;
	balance: string;
	countBalance: string;
	endBalance: string;
	initBalance: string;
	no: number;
	canEdit?: boolean;
}

let list: Appendix3Data[] = [
	{
		no: 1,
        typeName: "13%税率的项目",
        salesBalance: "",
		initBalance: "",
		balance: "",
		countBalance: "",
		actualBalance: "",
		endBalance: "",
		canEdit: true
	},
	{
		no: 2,
        typeName: "9%税率的项目",
        salesBalance: "",
		initBalance: "",
		balance: "",
		countBalance: "",
		actualBalance: "",
		endBalance: "",
		canEdit: true
	},
	{
		no: 3,
		typeName: "6%税率的项目（不含金融商品转让）",
        salesBalance: "",
		initBalance: "",
		balance: "",
		countBalance: "",
		actualBalance: "",
		endBalance: "",
		canEdit: true
	},
	{
		no: 4,
		typeName: "6%税率的金融商品转让项目",
        salesBalance: "",
		initBalance: "",
		balance: "",
		countBalance: "",
		actualBalance: "",
		endBalance: "",
		canEdit: true
	},
	{
		no: 5,
		typeName: "5%征收率的项目",
        salesBalance: "",
		initBalance: "",
		balance: "",
		countBalance: "",
		actualBalance: "",
		endBalance: "",
		canEdit: true
	},
	{
		no: 6,
		typeName: "3%征收率的项目",
        salesBalance: "",
		initBalance: "",
		balance: "",
		countBalance: "",
		actualBalance: "",
		endBalance: "",
		canEdit: true
	},
	{
		no: 7,
		typeName: "免抵退税的项目",
        salesBalance: "",
		initBalance: "",
		balance: "",
		countBalance: "",
		actualBalance: "",
		endBalance: "",
		canEdit: true
	},
	{
		no: 8,
		typeName: "免税的项目",
        salesBalance: "",
		initBalance: "",
		balance: "",
		countBalance: "",
		actualBalance: "",
		endBalance: "",
		canEdit: true
	}
];

let Appendix3 = list;
export default Appendix3;
